const ENV_CODE = process.env.VUE_APP_URL_ENV_CODE
const ENV_SUFFIX = ENV_CODE !== 'prod' ? `-${ENV_CODE}` : ''
const APP_SUBDOMAIN = process.env.VUE_APP_SUBDOMAIN
const BRANCH = process.env.VUE_APP_BRANCH

let DOMAIN = 'farmacloud.io'
if (!window.location.host.includes(':')) { // If is localhost, don't replace domain
  DOMAIN = window.location.hostname.split('.').slice(1).join('.')
}

export const TRANSLATIONS_ROUTE = `https://public-storage.farmacloud.io/applications/micro-frontends-translations/${BRANCH}/account-frontend/`
export const OAUTH_BASE_URL = `https://accountsbackend${ENV_SUFFIX}.${DOMAIN}`
export const ROOT_SITE = `https://${APP_SUBDOMAIN ? `${APP_SUBDOMAIN}.` : ''}${DOMAIN}/`
export const APPS_DASHBOARDS_URL = ROOT_SITE
export const FORM_BASE_URL = OAUTH_BASE_URL

export const LOGO_COLOR = 'https://public-storage.farmacloud.io/applications/custom-logos/farmacloud-color.png'
export const LOGO_WHITE = 'https://public-storage.farmacloud.io/applications/custom-logos/appcloud-white.png'

export const FARMACLOUD_BASE_URL = ''
export const FARMACLOUD_CLIENT_ID = ''
export const CONTACT_BASE_URL = ''
export const SIGNUP_WITH_GOOGLE = false
export const LOGIN_WITH_GOOGLE = false
